import {SET_SHOW_SHARE_SEQUENCE_MODAL} from 'constants/action-types.js';

let initialState = {
    showShareSequenceModal: false,
};

const modalsReducer = (state = initialState, action) => {
    switch (action.type) {
    case SET_SHOW_SHARE_SEQUENCE_MODAL:
        return {
            ... state,
            showShareSequenceModal: action.payload
        };
    default:
        return state;
    }
}

export default modalsReducer;
